import { render, staticRenderFns } from "./ShiftSummary.vue?vue&type=template&id=2b9a6400&"
import script from "./ShiftSummary.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftSummary.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports